import React from 'react'
import NavWidget from '../../../../widget/Nav/NavWidget'
import SidebarWidget from '../../../../widget/SidebarWidget/SidebarWidget'
import ComplaintsPageWidget  from './complaintPageWidget'
function Complaints() {
  return (
    <div>
        <NavWidget/>
        <div className='row'>
            <div className='col s12 m2 transparent'>
                <SidebarWidget/>
            </div>
            <div className='col s12 m10'>
                   <ComplaintsPageWidget/>
            </div>
        </div>
    </div>
  )
}

export default Complaints